function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { Text } from '@doordash/design-language';
import { PaginationContainer } from './styles';
import Pagination from '@doordash/component-numbered-pagination';
import { getRowRange } from './utils';

var TablePagination = function TablePagination(_ref) {
  var rows = _ref.rows,
      rowsPerPage = _ref.rowsPerPage,
      pageIndex = _ref.pageIndex,
      pageCount = _ref.pageCount,
      numPages = _ref.numPages,
      onPageChange = _ref.onPageChange,
      gotoPage = _ref.gotoPage,
      renderBeforePaginationContent = _ref.renderBeforePaginationContent,
      containerStyles = _ref.containerStyles,
      paginationProps = _ref.paginationProps,
      renderPagination = _ref.renderPagination;
  var numPaginationPages = numPages || pageCount;
  var displayPagination = rowsPerPage && rowsPerPage > 0;
  var beforePaginationContent = null;
  var customPagination = null;
  var handlePageChange = React.useCallback(function (pageNum) {
    if (onPageChange) {
      onPageChange({
        currentPage: pageIndex + 1,
        requestedPage: pageNum
      });
    }

    gotoPage(pageNum - 1);
  }, [pageIndex, onPageChange, gotoPage]);

  if (typeof renderPagination === 'function') {
    customPagination = function customPagination() {
      return renderPagination({
        currentPage: pageIndex + 1,
        numPages: numPaginationPages,
        changePage: handlePageChange
      });
    };
  }

  if (!!renderBeforePaginationContent) {
    if (typeof renderBeforePaginationContent === 'string') {
      beforePaginationContent = renderBeforePaginationContent;
    } else {
      var rowValues = getRowRange({
        rowsPerPage: rowsPerPage,
        pageIndex: pageIndex,
        totalRows: rows.length
      });
      beforePaginationContent = renderBeforePaginationContent(rowValues.from, rowValues.to, rows.length);
    }
  }

  return /*#__PURE__*/React.createElement(PaginationContainer, {
    showBeforePaginationContent: !!beforePaginationContent,
    customStyles: containerStyles
  }, customPagination && displayPagination && customPagination(), !customPagination && beforePaginationContent && /*#__PURE__*/React.createElement(Text, {
    styles: Text.Styles.PaginationNumberedDescription
  }, beforePaginationContent), !customPagination && displayPagination && /*#__PURE__*/React.createElement(Pagination // Note: These page number updates are needed because
  // react-table starts pagination at index 0, while
  // component-numbered-pagination starts at index 1
  , _extends({
    currentPage: pageIndex + 1,
    changePage: handlePageChange,
    numPages: numPaginationPages // To Do(lindsey-menges): remove this default in v7 and replace with an invariant if a Table
    // has pagination but has not provided an a11y label
    ,
    accessibilityLabel: "Table pagination control"
  }, paginationProps)));
};

export default TablePagination;